import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { GeneralService } from '.././../../../services/general/general.service';

// Calendar
import {
  CalendarOptions,
  EventApi,
  FullCalendarComponent,
} from '@fullcalendar/angular'; // useful for typechecking
import esLocale from '@fullcalendar/core/locales/es';
import enLocale from '@fullcalendar/core/locales/en-gb';
import ruLocale from '@fullcalendar/core/locales/ru';
import moment from 'moment';
import 'moment-timezone';
import { environment } from 'src/environments/environment';
import { DateTime, Zone } from 'luxon';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-availability',
  templateUrl: './availability.component.html',
  styleUrls: ['../../../../..//shared-styles/calendar.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AvailabilityComponent implements OnInit {
  @ViewChild('calendar') calendarComponent: FullCalendarComponent | undefined;

  public isMobile: any;
  public timeZone: any;
  public headerHeight: any = 0;
  public loading: any = false;
  public updatingEvents: any = false;
  public subscriptions: any = [];

  // Calendar
  public calendarOptions: CalendarOptions = {};
  public lastEventClicked: any = null;
  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private dialog: MatDialog
  ) {
    this.isMobile = this.general.isMobile();
    this.timeZone = this.general.getCurrentTimezone();

    this.calendarOptions = {
      height: 630,
      initialView: 'timeGridWeek',
      allDaySlot: false,
      slotLabelFormat: {
        hour: '2-digit',
        minute: this.isMobile ? undefined : '2-digit',
        omitZeroMinute: false,
        meridiem: false,
        hour12: false,
      },
      eventMinHeight: 30,
      dayHeaderFormat: {
        weekday: this.isMobile ? 'narrow' : 'short',
      },
      locales: [esLocale, enLocale, ruLocale],
      locale:
        this.general.translate.currentLang === 'en'
          ? 'en-gb'
          : this.general.translate.currentLang,
      firstDay: 1,
      headerToolbar: false,
      editable: true,
      events: [],
      dateClick: this.handleDateClick.bind(this), // bind is important!
      eventClick: this.handleEventClick.bind(this),
      eventAllow: this.handleAllowEventSize.bind(this),
      eventLongPressDelay: 300,
      eventOverlap: false,
      eventsSet: this.handleEventSet.bind(this),
      timeZone: this.timeZone,
      // eventResize: this.handleEventRes.bind(this)
    };
  }

  async ngOnInit() {
    try {
      window.dispatchEvent(new CustomEvent('calendar-hide-label'));

      this.intializeSubscriptions();
      // if (environment.production) {
      //   this.general.showInfiniteWarning('web-under-construction');
      // }

      this.general.setLoading(true);
      document.addEventListener('set-lang', this);
      const response = await this.general.httpGet('schedule');
      
      // Events
      const calendarApi: any = this.calendarComponent?.getApi();      
      let timezone = '';
      Object.keys(response.data.days).some((key: any, index: number) => {
        if (index === 0) {
          timezone = response.data.days[key][0].timezone;
          return true;
        }
        return false;
      });
      this.addTimezone();      


      let startDate = calendarApi?.view.currentStart;
      let days: any = {};
      /*for (var i = 1; i <= 7; i++) {
        if (i != 7) {
          days[i] = moment.tz(startDate, this.general.getCurrentTimezone()).add(i, 'days');
        } else {
          days[0] = moment.tz(startDate, this.general.getCurrentTimezone()).add(i, 'days');
        }
      }*/
      for (const dayKey in response.data.days) {
        if (response.data.days.hasOwnProperty(dayKey)) {
          const dayArray = response.data.days[dayKey];
          for (let i = 0; i < dayArray.length; i++) {
            const item = dayArray[i];
            if(item.day_index == 0){
              item.day_index = 6;
            }else{
              item.day_index = item.day_index - 1;
            }
          }
        }
      }
      for (var i = 0; i <= 6; i++) {
        days[i] = moment.tz(startDate, this.general.getCurrentTimezone()).add(i, 'days');
      }

      Object.keys(response.data.days).forEach((key: any, index: number) => {
        response.data.days[key].forEach((range: any) => {
          const start = DateTime.fromJSDate(days[range.day_index].toDate())
            .setZone(range.timezone)
            .set({
              hour: range.start.split(':')[0],
              minute: range.start.split(':')[1]
            })
            .setZone(this.general.getCurrentTimezone());
            
          const end = DateTime.fromJSDate(days[range.day_index].toDate())
            .setZone(range.timezone)
            .set({
              hour: range.end.split(':')[0],
              minute: range.end.split(':')[1],
            })
            .setZone(this.general.getCurrentTimezone());

          if (start.toFormat('c') !== end.toFormat('c')) {
            const event1 = {
              start: start.toString(),
              end: start.set({ hour: 23, minute: 59 }).toString(),
              id: this.general.getRandomId(10),
            };
            calendarApi?.addEvent(event1);

            const event2 = {
              start: end.set({ hour: 0, minute: 0 }).toString(),
              end:
                end.get('minute') === 59 && end.get('hour') != 23
                  ? end.set({ hour: end.get('hour') + 1, minute: 0 }).toString()
                  : end.toString(),
              id: this.general.getRandomId(10),
            };

            if (event2.start === event2.end) {
              return;
            }
            calendarApi?.addEvent(event2);
          } else {
            const event = {
              start: start.toString(),
              end:
                end.get('minute') === 59 && end.get('hour') != 23
                  ? end.set({ hour: end.get('hour') + 1, minute: 0 }).toString()
                  : end.toString(),
              id: this.general.getRandomId(10),
            };

            calendarApi?.addEvent(event);
          }
        });
      });
    } catch (error: any) {
      console.log(error);
      await this.general.showDanger(error.message);
    } finally {
      this.general.setLoading(false);
    }
  }

  ngOnDestroy() {
    document.removeEventListener('set-lang', this);

    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  /**
   * =================== Calendar ===================
   */
  async handleEventSet(args: any) {
    try {
      if (!this.loading && !this.updatingEvents) {
        this.updatingEvents = true;
        let calendarApi = this.calendarComponent?.getApi();

        let events: any = calendarApi?.getEvents();

        //this.refactorEvents(events, this.timeZone);

        let scheedule: any = this.createNewScheeduleEstructure(
          events,
          this.timeZone
        );

        const response = await this.general.httpPost('schedule', {
          schedule: JSON.stringify(scheedule),
          timezone: this.timeZone,
        });
        this.updatingEvents = false;
      }
    } catch (error: any) {
      console.log(error);
      await this.general.showDanger(error.message);
      this.updatingEvents = false;
    }
  }

  // Handle event Listener
  handleEvent(event: any) {
    switch (event.type) {
      case 'set-lang':
        this.calendarOptions.locale =
          event.detail === 'en' ? 'en-gb' : event.detail;
        break;
    }
  }

  handleDateClick(args: any) {
    let calendarApi = this.calendarComponent?.getApi();

    const dateStart = DateTime.fromISO(args.dateStr, {
      zone: this.timeZone,
    });
    let dateEnd = DateTime.fromISO(args.dateStr, {
      zone: this.timeZone,
    });

    if (dateStart.get('hour') === 23 && dateStart.get('minute') === 30) {
      return;
    }

    if (dateStart.get('hour') + 1 === 24) {
      dateEnd = dateEnd.plus({ minute: 59 });
    } else {
      dateEnd = dateEnd.plus({ hour: 1 });
    }

    // Check if already exist an event between dates
    const events: any = calendarApi?.getEvents();
    const exit = events.find((event: any) => {
      const currentEventStart = DateTime.fromISO(event.startStr, {
        zone: this.timeZone,
      });
      const currentEventEnd = DateTime.fromISO(event.endStr, {
        zone: this.timeZone,
      });

      if (
        (dateStart.toMillis() >= currentEventStart.toMillis() &&
          dateStart.toMillis() < currentEventEnd.toMillis()) ||
        (dateEnd.toMillis() > currentEventStart.toMillis() &&
          dateEnd.toMillis() <= currentEventEnd.toMillis())
      ) {
        return event;
      }
    });
    if (exit) {
      return;
    }
    const event = {
      start: dateStart.toString(),
      end: dateEnd.toString(),
      id: this.general.getRandomId(10),
    };

    calendarApi?.addEvent(event);
  }

  handleEventClick(args: any) {
    this.lastEventClicked = args.event;

    const removeDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'sure-remove-availability',
      },
      autoFocus: false,
    });

    const subscribed = removeDialogRef.afterClosed().subscribe((response) => {
      subscribed.unsubscribe();
      if (!response) {
        return;
      }
      this.removeLastEventClicked();
    });
  }

  handleAllowEventSize(args: any) {
    const calendarApi = this.calendarComponent?.getApi();

    const timezone: any = calendarApi?.getOption('timeZone');
    let start = DateTime.fromISO(args.startStr).setZone(timezone);
    let end = DateTime.fromISO(args.endStr).setZone(timezone);
    if (
      start.toLocaleString() === end.toLocaleString() ||
      start.toLocaleString() === end.minus({ minutes: 1 }).toLocaleString()
    ) {
      return true;
    } else {
      return false;
    }
  }

  removeLastEventClicked() {
    if (this.lastEventClicked !== null) {
      this.lastEventClicked.remove();
      this.lastEventClicked = null;
    }
  }

  onGetHeight(height: any) {
    if (height) {
      this.headerHeight = height;
    }
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  createNewScheeduleEstructure(events: EventApi[] = [], timezone: string) {
    let scheedule: any = [];

    events?.forEach((event: any) => {
      let start = DateTime.fromISO(event.startStr).setZone(timezone);
      let end = DateTime.fromISO(event.endStr).setZone(timezone);
      if (end.hour === 0) {
        end = end.set({
          hour: 23,
          minute: 59,
        });
      }

      let day_index = start.weekday === 7 ? 0 : start.weekday;
      let scheeduleDay = scheedule.find(
        (scheDay: any) => scheDay.day_index === day_index
      );

      if (scheeduleDay) {
        scheeduleDay.start_hours.push(start.toFormat('HH:mm'));
        scheeduleDay.end_hours.push(end.toFormat('HH:mm'));
      } else {
        scheeduleDay = {
          day_index: day_index,
          start_hours: [start.toFormat('HH:mm')],
          end_hours: [end.toFormat('HH:mm')],
        };
        scheedule.push(scheeduleDay);
      }
    });
    return scheedule;
  }

  addTimezone() {
    const calendarApi = this.calendarComponent?.getApi();
    calendarApi?.setOption('timeZone', this.general.getCurrentTimezone());
    calendarApi?.refetchEvents();
  }

  refactorEvents(events: any, timezone: string) {
    events.forEach((event: any) => {
      const end = DateTime.fromISO(event.endStr).setZone(timezone);
      if (
        (end.get('minute') === 59 && end.get('hour') !== 23) ||
        end.get('minute') === 29
      ) {
        event.setEnd(
          end
            .plus({
              minutes: 1,
            })
            .toString()
        );
      } else if (end.get('minute') === 0 && end.get('hour') === 0) {
        event.setEnd(
          end
            .minus({
              minutes: 1,
            })
            .toString()
        );
      }
    });
  }
}
